import { LinkOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { EmailSend } from 'ui/icons';
import { useTranslation } from 'modules/domains/list';
import { createEmailListIdParams } from '../../../utils';
import { LIST_SIGNUP_FORM_URL } from '../../../constants';
import { List } from '../../../types';

export const useSignupFormLink = (list: List): LinkOption => {
  const { t } = useTranslation();
  const href = createEmailListIdParams(list, LIST_SIGNUP_FORM_URL);

  return {
    as: AllowedActionMenuElements.Link,
    href,
    content: (
      <>
        <EmailSend height={16} width={16} />
        <span>{t('indexPage.table.overflowMenu.signup')}</span>
      </>
    ),
    id: 'list-sign-up-link',
  };
};
